import { Pipe } from '@angular/core';
import { isArray, takeWhile, isNil } from '../utils/utils';
var TakeWhilePipe = (function () {
    function TakeWhilePipe() {
    }
    TakeWhilePipe.prototype.transform = function (input, predicate) {
        if (!isArray(input) || isNil(predicate)) {
            return input;
        }
        return takeWhile(input, predicate);
    };
    return TakeWhilePipe;
}());
export { TakeWhilePipe };
TakeWhilePipe.decorators = [
    { type: Pipe, args: [{
                name: 'takeWhile'
            },] },
];
/** @nocollapse */
TakeWhilePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=take-while.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/take-while.pipe.js
// module id = 250
// module chunks = 103